module.exports = __webpack_public_path__ + "img/blank-comic-book_B09914G4YY.73913276.jpg";